export const SET_API_CACHE = '@api-cache/set';
export const CLEAR_API_CACHE_BY_PREFIX = '@api-cache/clear-by-prefix';
export const CLEAR_ALL_API_CACHE = '@api-cache/clear-all';

export interface ApiCacheEntry<T = unknown> {
  data: T;
  timestamp: number;
}

export const setApiCache = <T = unknown>(key: string, data: T) => ({
  type: SET_API_CACHE,
  payload: {
    key,
    entry: { data, timestamp: Date.now() } as ApiCacheEntry<T>,
  },
});

export const clearApiCacheByPrefix = (prefix: string) => ({
  type: CLEAR_API_CACHE_BY_PREFIX,
  payload: { prefix },
});

export const clearAllApiCache = () => ({
  type: CLEAR_ALL_API_CACHE,
});
